<div class="map__container">
  <div #mapElement  class="map"></div>  
  <ion-icon class="marker" src="/assets/icon/location-color.svg"></ion-icon>
</div>
  <!-- <ion-button (click)="current_locate()">Currnet</ion-button> -->